import { TimeboxSessionType } from '@demind-inc/core';

export const TIMEBOX_PREFS_ITEMS_INFO: Record<
  TimeboxSessionType,
  { title: string; titleKey: string }
> = {
  deepWork: { title: '🧠 Deep work', titleKey: 'settings.aiAssistant.timeboxes.deepWork' },
  lightWork: { title: '✏️ Light task', titleKey: 'settings.aiAssistant.timeboxes.lightTask' },
};
